<template>
  <div class="charts-container">
    <el-row>
      <el-col>
        <ContentBox title="到达曲线">
          <VeLine
            :data="reachLine.data"
            :settings="reachLine.settings"
            :extend="reachLine.extend"
            :legend-visible="false"
            :colors="['#23ccd6']"
            :loading="loading"
            height="300px"
          >
            <ChartDataEmpty v-if="reachLine.data.rows.length === 0" />
          </VeLine>
        </ContentBox>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <ContentBox>
          <div class="download" slot="title">
            <p class="title">曝光数据</p>
            <div class="title-right">
              <p class="title-right-radio">
                <el-radio-group size="mini" v-model="reachType">
                  <el-radio-button :label="1">频控到达</el-radio-button>
                  <el-radio-button :label="2">累计到达</el-radio-button>
                </el-radio-group>
              </p>
              <p>
                <el-button size="mini">
                  <i class="el-icon-cc-unorderedlist" style="font-size: 12px;padding-right:4px"></i>导出
                </el-button>
              </p>
            </div>
          </div>
          <div>
            <Table :props="table.props" :header="exporeTabelHeader" :data="table.data" />
            <pagination
              :currentpage="currentPage"
              :pagesize="pageSize"
              :totalcount="totalCount"
              @handle-size-change="handleSizeChange"
              @handle-current-change="handleCurrentChange"
            ></pagination>
          </div>
        </ContentBox>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import ChartDataEmpty from '@/components/ChartDataEmpty'
import VeLine from 'v-charts/lib/line.common'
import 'v-charts/lib/style.css'
export default {
  components: {
    VeLine,
    ChartDataEmpty
  },
  data() {
    return {
      isShowSelect: false,
      isShowTimePicker: false,
      showType: 1,
      reachType: 1,
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      // 到达数据曲线
      reachLine: {
        data: {
          columns: ['xData', 'yData'],
          rows: []
        },
        settings: {
          labelMap: { yData: '展示数' },
          yAxisName: ['pv']
        },
        extend: this.$consts.basicLineExtend
      },
      table: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '计划名称',
            align: 'left',
            prop: 'scheduleName',
            fixed: true,
            'min-width': 150,
            'show-overflow-tooltip': true
          },
          {
            label: '广告位',
            align: 'left',
            prop: 'spaceName',
            'min-width': 150,
            'show-overflow-tooltip': true
          },
          {
            label: '时间',
            align: 'left',
            prop: 'putTime',
            'min-width': 230,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              if (params.putTime) {
                const time = params.putTime.replace('||', ' ~ ')
                return time
              } else {
                return '-'
              }
            }
          },
          {
            label: '总曝光终端(UV)',
            align: 'right',
            prop: 'deviceNum',
            'min-width': 150,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return (params.deviceNum || 0).toLocaleString()
            }
          },
          {
            label: '总曝光数(PV)',
            align: 'right',
            prop: 'totalPv',
            'min-width': 150,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return (params.totalPv || 0).toLocaleString()
            }
          },
          {
            label: '1次',
            align: 'right',
            prop: 'pv1',
            'min-width': 100,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return (params.pv1 || 0).toLocaleString()
            }
          },
          {
            label: '2次',
            align: 'right',
            prop: 'pv2',
            'min-width': 100,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return (params.pv2 || 0).toLocaleString()
            }
          },
          {
            label: '3次',
            align: 'right',
            prop: 'pv3',
            'min-width': 100,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return (params.pv3 || 0).toLocaleString()
            }
          },
          {
            label: '4次',
            align: 'right',
            prop: 'pv4',
            'min-width': 100,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return (params.pv4 || 0).toLocaleString()
            }
          },
          {
            label: '5次',
            align: 'right',
            prop: 'pv5',
            'min-width': 100,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return (params.pv5 || 0).toLocaleString()
            }
          },
          {
            label: '6次',
            align: 'right',
            prop: 'pv6',
            'min-width': 100,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return (params.pv6 || 0).toLocaleString()
            }
          },
          {
            label: '7次',
            align: 'right',
            prop: 'pv7',
            'min-width': 100,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return (params.pv7 || 0).toLocaleString()
            }
          },
          {
            label: '8次',
            align: 'right',
            prop: 'pv8',
            'min-width': 100,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return (params.pv8 || 0).toLocaleString()
            }
          },
          {
            label: '9次',
            align: 'right',
            prop: 'pv9',
            'min-width': 100,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return (params.pv9 || 0).toLocaleString()
            }
          },
          {
            label: '10次以上',
            align: 'right',
            prop: 'pv10',
            'min-width': 100,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return (params.pv10 || 0).toLocaleString()
            }
          }
        ],
        data: []
      },
      loading: false
    }
  },
  props: {
    scheduleChartData: {
      type: Object
    }
  },
  watch: {
    reachType(newValue, oldValue) {
      if (this.scheduleChartData.orderId) {
        this.getTableData()
      }
    }
  },
  computed: {
    exporeTabelHeader() {
      let header = []
      if (this.reachType === 2) {
        header = this.table.header.filter((item) => item.prop !== 'putTime')
      } else {
        header = this.table.header
      }

      return header
    }
  },
  methods: {
    handleSizeChange: function (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getTableData()
    },
    // 页码变更, 如第1页变成第2页时,val=2
    handleCurrentChange: function (val) {
      this.currentPage = val
      this.getTableData()
    },
    fetchData() {
      if (this.scheduleChartData.orderId) {
        this.loading = true
        let form = {
          orderId: this.scheduleChartData.orderId,
          scheduleId: this.scheduleChartData.scheduleId
        }
        this.$service.getReachReport(form).then((data) => {
          this.loading = false
          this.reachLine.data.rows = data.lineList || []
        })
        this.getTableData()
      }
    },
    // 详细数据
    getTableData() {
      let form = {
        orderId: this.scheduleChartData.orderId,
        scheduleId: this.scheduleChartData.scheduleId,
        pageSize: this.pageSize,
        pageNo: this.currentPage
      }
      if (this.reachType === 1) {
        form.pageSize = this.pageSize
        form.pageNo = this.currentPage
        this.$service.getFrequencyPageList(form).then((data) => {
          this.table.data = data.rows || []
          this.totalCount = data.total
        })
      }
      if (this.reachType === 2) {
        form.pageSize = 10
        form.pageNo = 1
        this.$service.getReachReport(form).then((data) => {
          this.table.data = data.reachList || []
          const totalCount = Number(data.total)
          this.totalCount = isNaN(totalCount) ? 0 : totalCount
        })
      }
    }
  },
  created() {
    this.fetchData()
  }
}
</script>
<style lang="stylus" scoped>
.charts-container
  background #f2f2f2
  padding 16px 16px 0
  overflow auto
  height calc(100vh - 116px)
p
  margin 0px
>>> .el-radio-button--medium .el-radio-button__inner
  min-width 100px
.download
  width 100%
  display flex
  justify-content space-between
  padding-right 20px
  align-items center
.title-right
  display flex
  align-items center
.title-right-radio
  margin-right 10px
</style>
